var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Primetime = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return (this.player.localTime / 1000) //|| (this.player.currentTime / 1000)
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    if (this.flags.isPaused) return 0
    if (this.player.playbackMetrics) {
      return this.player.playbackMetrics.playbackRate
    }
    return 1
  },

  /** Override to return Frames Per Second (FPS) */
  getFramesPerSecond: function () {
    if (this.player.playbackMetrics) {
      if (!isNaN(this.player.playbackMetrics.frameRate)) {
        return this.player.playbackMetrics.frameRate
      }
    }
    return null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    if (this.player.playbackMetrics && this.player.playbackMetrics.droppedFramesCount) {
      return this.player.playbackMetrics.droppedFramesCount.video
    }
    return 0
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.playbackRange.duration / 1000 || null
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    return this.player.playbackMetrics.bitRate.video || this.player.playbackMetrics.bitRate || -1
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    return this.player.playbackMetrics.perceivedBandwidth.video || -1
  },

  /** Override to return rendition */
  getRendition: function () {
    var bitrate = this.getBitrate()
    if (!isNaN(bitrate) && bitrate > 0) {
      return youbora.Util.buildRenditionString(
        this.player.view.width,
        this.player.view.height,
        bitrate
      )
    }
    return null
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.currentItem ? this.player.currentItem.live : false
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.currentItem ? this.player.currentItem.resource.url : 'Unknown'
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    if (AdobePSDK && AdobePSDK.Version) {
      return AdobePSDK.Version.version
    }
    if (this.player.getVersion) {
      return this.player.getVersion()
    }
    return null
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Primetime'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    //this.monitorPlayhead(true, false)

    this.event = AdobePSDK.PSDKEventType
    // References
    this.references = []
    this.references[this.event.STATUS_CHANGED] = this.statusListener.bind(this)
    this.references[this.event.PLAY_START] = this.playingListener.bind(this)
    this.references[this.event.OPERATION_FAILED] = this.errorListener.bind(this)
    this.references[this.event.SEEK_BEGIN] = this.seekingListener.bind(this)
    this.references[this.event.SEEK_END] = this.seekedListener.bind(this)
    this.references[this.event.BUFFERING_BEGIN] = this.bufferingListener.bind(this)
    this.references[this.event.BUFFERING_END] = this.bufferedListener.bind(this)
    this.references[this.event.TIME_CHANGED] = this.timechangedListener.bind(this)
    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  timechangedListener: function () {
    if (!this.flags.isStarted) {
      this.fireStart()
      this.acumAdTime = 0
    }
    if (this.getPlayhead() > 0.1) {
      this.fireJoin()
    }
  },

  statusListener: function (e) {
    if (!this.plugin.getAdsAdapter()) this.plugin.setAdsAdapter(new youbora.adapters.Primetime.PrimetimeAds(this.player))
    switch (this.player.status) {
      case this.player.PLAYER_STATUS_COMPLETE:
        youbora.Log.debug("New Status: COMPLETE " + this.player.status)
        this.fireStop()
        break
      case this.player.PLAYER_STATUS_IDLE:
        youbora.Log.debug("New Status: IDLE " + this.player.status)
        if (this.player.status === 0) this.fireStop()
        break
      case this.player.PLAYER_STATUS_INITIALIZED:
        youbora.Log.debug("New Status: INITIALIZED " + this.player.status)
        break
      case this.player.PLAYER_STATUS_INITIALIZING:
        youbora.Log.debug("New Status: INITIALIZING " + this.player.status)
        break
      case this.player.PLAYER_STATUS_PAUSED:
        youbora.Log.debug("New Status: PAUSED " + this.player.status)
        if (this.plugin.getAdsAdapter() && this.plugin.getAdsAdapter().flags.isStarted) {
          this.plugin.getAdsAdapter().firePause()
        } else {
          this.firePause()
        }
        break
      case this.player.PLAYER_STATUS_PLAYING:
        youbora.Log.debug("New Status: PLAYING " + this.player.status)
        if (this.plugin.getAdsAdapter() && this.plugin.getAdsAdapter().flags.isPaused) {
          this.plugin.getAdsAdapter().fireResume()
        } else {
          this.fireResume()
        }
        break
      case this.player.PLAYER_STATUS_RELEASED:
        youbora.Log.debug("New Status: RELEASED " + this.player.status)
        break
      case this.player.PLAYER_STATUS_PREPARING:
        youbora.Log.debug("New Status: PREPARING " + this.player.status)
        this.fireStart()
        this.acumAdTime = 0
        break
      case this.player.PLAYER_STATUS_PREPARED:
        youbora.Log.debug("New Status: PREPARED " + this.player.status)
        break
      case this.player.PLAYER_STATUS_SEEKING:
        youbora.Log.debug("New Status: SEEKING " + this.player.status)
        break
      case this.player.PLAYER_STATUS_ERROR:
        youbora.Log.debug("New Status: ERROR " + this.player.status)
        break
      default:
        youbora.Log.debug("New Status: UNKNOWN " + this.player.status)
        break
    }
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    if (!this.plugin.getAdsAdapter() || (this.plugin.getAdsAdapter() && !this.plugin.getAdsAdapter().flags.isStarted)) {
      this.fireResume()
      this.fireSeekEnd()
      this.fireBufferEnd()
      if (this.getPlayhead() > 0.1) {
        this.fireJoin()
      }
    }
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    if (e.notification.code !== AdobePSDK.PSDKErrorCode.GENERIC_ERROR) {
      var metadata = e.metadata ? e.metadata : e.notification.metadata
      var err = {
        errorCode: e.notification.code,
        msg: metadata.getValue ? metadata.getValue('DESCRIPTION') : 'UNKNOWN ERROR',
        resource: metadata.getValue ? metadata.getValue('URL') : this.getResource()
      }
      this.fireError(err)
    }
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    if (!this.plugin.getAdsAdapter() || (this.plugin.getAdsAdapter() && !this.plugin.getAdsAdapter().flags.isStarted)) {
      this.fireSeekBegin()
    }
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    this.fireSeekEnd()
  },

  /** Listener for 'buffering' event. */
  bufferingListener: function (e) {
    if (!this.plugin.getAdsAdapter() || (this.plugin.getAdsAdapter() && !this.plugin.getAdsAdapter().flags.isStarted)) {
      this.fireBufferBegin()
    }
  },

  /** Listener for 'buffered' event. */
  bufferedListener: function (e) {
    this.fireBufferEnd()
  }
}, {
    PrimetimeAds: require('./ads/primetimeAds')
  }
)

module.exports = youbora.adapters.Primetime



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 29
// module chunks = 0